import { request } from '../../src/utils/request';

export async function getSearchTennisAPI(
    longitude?: string,
    latitude?: string,
    isWeekend?: boolean,
    location?: string,
    building_id?: string,
    tokyo_building_id?: string
) {
    try {
        // 构建查询参数
        const queryParams = new URLSearchParams();
        if (longitude !== undefined) {
            queryParams.append('longitude', longitude);
        }
        if (latitude !== undefined) {
            queryParams.append('latitude', latitude);
        }
        if (isWeekend !== undefined) {
            queryParams.append('isWeekend', isWeekend.toString());
        }
        if (location !== undefined && location !== "") {
            queryParams.append('location', location);
        }
        if (building_id !== undefined && building_id !== "") {
            queryParams.append('building_id', building_id);
        }
        if (tokyo_building_id !== undefined && tokyo_building_id !== "") {
            queryParams.append('tokyo_building_id', tokyo_building_id);
        }

        // 发送请求
        const response = await request({
            url: `/api/searchTennis?${queryParams.toString()}`,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
            timeout: 1000000,
        });

        // 处理响应数据
        const data: any = response;
        console.log('data:', data);

        if (data) {
            return { statusCode: 200, message: data.message, TennisList: data.output };
        } else {
            throw new Error(data.error || 'Failed to fetch tennis search result');
        }
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
}

// 获取保存的 Tokyo 结果
export function getTokyoResultAPI(): Promise<any> {
  return request({
    url: "/api/saveTokyoResult",
    method: "GET",
    headers: {
        'Content-Type': 'application/json',
    },
  });
}

// 保存 Tokyo 结果到 Redis
export async function saveTokyoResultAPI(data: any, timestamp?: number) {
  try {
    const response = await request({
      url: "/api/saveTokyoResult",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        data,
        timestamp: timestamp || Date.now(),
      },
    });

    const res: any = response;
    if (res.success) {
      return { success: true, timestamp: res.timestamp };
    } else {
      throw new Error(res.message || "保存失败");
    }
  } catch (error) {
    console.error("保存Tokyo结果失败:", error);
    throw error;
  }
}